import { Injectable } from '@angular/core';
import { CqrsService } from '../service-model/cqrs-service.interface';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { ProtocolQuery } from '../service-model/protocol-query.interface';
import { WebCommand } from '../service-model/web-command.interface';
import { ProtocolCommand } from '../service-model/protocol-command.interface';
import { timeout } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class TelemetryBackendClientService implements CqrsService {
  constructor(
    private readonly httpClient: HttpClient
  ) {
    this.commandUrl = `${environment.telemetryServiceUrl}/processCommand`;
  }

  private readonly commandUrl: string;

  public processQuery<T>(query: ProtocolQuery): Promise<T> {
    throw new Error('Not implemented');
  }

    public processCommand(command: ProtocolCommand, requestTimeoutMs?: number): Promise<any> {
    const requestData: string = JSON.stringify(command);
    const operation: string = command.getOperationName();
    const webCommand: WebCommand = { type: operation, data: requestData };
        const request = this.httpClient.post(this.commandUrl, webCommand);
        return (requestTimeoutMs ? request.pipe(timeout(requestTimeoutMs)) : request).toPromise();
  }
}
